import { makeStyles, Text, tokens } from '@fluentui/react-components';
import type { PropsWithChildren, ReactNode } from 'react';

import { spacing } from '@/theme/tokens';

const useStyles = makeStyles({
  card: {
    borderRadius: tokens.borderRadiusXLarge,
    backgroundColor: tokens.colorNeutralBackground2,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    padding: spacing.l,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.m,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.s,
  },
  title: {
    color: tokens.colorNeutralForeground1,
  },
  description: {
    color: tokens.colorNeutralForeground3,
  },
});

interface SectionCardProps {
  title?: string;
  description?: string;
  trailing?: ReactNode;
}

export function SectionCard({
  title,
  description,
  trailing,
  children,
}: PropsWithChildren<SectionCardProps>) {
  const classes = useStyles();
  const hasHeader = title ?? trailing;
  return (
    <section className={classes.card}>
      {hasHeader ? (
        <div className={classes.header}>
          <div>
            {title ? (
              <Text className={classes.title} size={400} weight="semibold">
                {title}
              </Text>
            ) : null}
            {description ? (
              <div>
                <Text className={classes.description} size={200}>
                  {description}
                </Text>
              </div>
            ) : null}
          </div>
          {trailing}
        </div>
      ) : null}
      {children}
    </section>
  );
}
